import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/img/logo.svg";
// import IMG from "../../../assets/img/landing/lnd_pg_img_2.png";
import IOS from "../assets/img/app_btn_Ios.svg";
import qr from "../assets/img/qr1.png";
import smily from "../assets/img/rewards/smily.png";
import AccountFooter from "../components/AccountFooter";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
// import { getUserToken } from "../../../libs/user";
// import { useDispatch, useSelector } from "react-redux";
// import { getUserRewards } from "../../../redux/slices/rewardSlice";
import AndroidDownloadIcon from "../assets/img/google-play-badge.png";
import { Dwnld_CTA_clicked, getUtmSource } from "../libs/events";
import $ from "jquery";
import SnackBar from "../components/SnackBar";
import { getaddedbank } from "../services/plaid";
import { getUser, getUserToken } from "../libs/user";
import { REMITTANCE_SIGNUP } from "../config/constants";
import googleplay from "../assets/img/G-Play.png";
import applestore from "../assets/img/A-Store.png";
import { useSelector } from "react-redux";

function GetApp() {
  // const dispatch = useDispatch();
  const authToken = getUserToken();
  // const { userRewards } = useSelector((state) => state.reward);
  const [bankStatus, setBankStatus] = useState(null);
  const [isbankCard, setIsBankCard] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [bank, setBank] = useState(null);
  const [topcardResponse, setTopcardResponse] = useState(false);

  const interval3 = useRef();
  const navigate = useNavigate();

  const userRewards = { data: [] };
  const utmSource = getUtmSource();
  const [bodyHeight, setBodyHeight] = useState();
  const [mailUpdated, setMailUpdated] = useState("");


  const downloadApp = (platform) => {
    if (platform === "iOS") {
      Dwnld_CTA_clicked({ platform_selected: "iOS" });
      window.location =
        "https://apps.apple.com/us/app/times-club-rewards-cash/id1477331331";
    } else if (platform === "Android") {
      Dwnld_CTA_clicked({ platform_selected: "Android" });
      window.location =
        "https://play.google.com/store/apps/details?id=co.timesclub.rewards&hl=en_IN&gl=US";
    }
  };

  // const getTopCards = (cards) => {
  //   console.log(cards);
  //   cards.forEach((data) => {
  //     if (
  //       [
  //         "pending_bank_link",
  //         "confirmed_bank_link",
  //         "duplicate_bank_link",
  //         "manual_verification_bank_link",
  //       ].includes(data.eventType)
  //     ) {
  //       console.log("bank card: ", true);
  //       setIsBankCard(true);
  //     }
  //   });
  //   if (cards.length > 0) {
  //     if (cards[0].eventType === "confirmed_bank_link") {
  //       setBankStatus("confirmed_bank_link");
  //     } else {
  //       setBankStatus(null);
  //     }
  //   }
  // };

  const getUsersBank = (authToken) => {
    // setTopcardResponse(false);
    getaddedbank(authToken)
      .then((response) => {
        setTopcardResponse(true);
        try {
          if (response?.details.length > 0) {
            setBank(response?.details[0]);
            setBankStatus("confirmed_bank_link");
            clearInterval(interval3.current);
          }
          // console.log(response);
        } catch (error) {
          setBankStatus(null);
          console.log(error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // dispatch(
    //   getUserRewards({
    //     token: authToken,
    //   })
    // );

    if (utmSource === "toi_js_bridge") {
      const callbackData = JSON.parse(
        sessionStorage.getItem("callbackData") || "{}"
      );
      window.tcWebBridge.sendUserState(callbackData);
    }
  }, []);

  useLayoutEffect(() => {
    const headerHeight = $(".header").outerHeight();
    const footerHeight = $(".footer").outerHeight();
    setBodyHeight(
      parseFloat($(window).outerHeight() || 0) -
        (parseFloat(headerHeight || 0) + parseFloat(footerHeight || 0))
    );
  }, []);
  useEffect(() => {
    if (utmSource === "toi_js_bridge") {
      getUsersBank(authToken);
      interval3.current = setInterval(() => {
        getUsersBank(authToken);
      }, 10000);
      return () => {
        clearInterval(interval3.current);
      };
    }
  }, []);
  // console.log("refreshing...", bank);
  const fetchUserData = async()=>{
    const storedUserData = await getUser();
    const mailUpdated = storedUserData?.user?.email_updated;
    setMailUpdated(mailUpdated)
  }

  useEffect(()=>{
    fetchUserData();
    if(authToken){
      if(!mailUpdated&& mailUpdated!==""){
        navigate("/signup", {replace: true})
      }  
    }
  },[authToken, mailUpdated])

  return (
    <div>
      {utmSource === "toi_js_bridge" &&
        bank === null &&
        topcardResponse === true && (
          <div>
            <div className="snack-bar linking">
              <div className="snack-bar-info">
                <div className="spinner-border"></div>
                <p> Pending </p>
              </div>
            </div>
          </div>
        )}
      {utmSource === "toi_js_bridge" && bank !== null && (
        <div className="snack-bar success">
          <div className="snack-bar-info">
            <div className="bank-icon">
              <span className="bank-rgt-icon"></span>
            </div>

            <p data-index={0}> Your bank has been linked. </p>
          </div>
        </div>
      )}
      {utmSource !== "toi_js_bridge" && <SnackBar />}

      <div className="header">
        <div className="container">
          <div className="headTop">
            {/* <a href="/" className="logo">
              <img src={Logo} />
            </a> */}
            <div className="topNav">
              <Link to="#" className="navLink ">
                Get Started
              </Link>
              <Link to="#" className="navLink ">
                Complete Registration
              </Link>
              {/* <Link to="#" className="navLink ">
                Offers
              </Link> */}
              <Link to="#" className="navLink active">
                Get the App
              </Link>
            </div>
            <div className="mobCurrentPage">
              <span className="curntPgNo">3 of 3</span> Rewards
            </div>
          </div>
        </div>
      </div>
      <div className="containtSec" style={{ minHeight: `${bodyHeight}px` }}>
        {/* <div className="container">
          <div className="acntContntRow">
            <div className="actntCntLeftCol">
              <div className="getAppHed">
                <div className="hedSec">
                  <h2>
                    Welcome to the Club!
                    <br />
                    We have $5 Waiting for You.
                  </h2>
                  <h3>
                    Download the app and sign in to see your reward. Start
                    earning cash back on exclusive offers today!
                  </h3>
                </div>
              </div>
              <div className="getAppFrm">
                <p className="frmTxt">
                  Enter your phone number to get a link (optional).
                </p>
                <div className="formGroup">
                  <input
                    type="text"
                    className="frmControl"
                    placeholder="123-456-7890"
                  />
                </div>
                <div className="formGroup">
                  <button type="button" className="btnPrimary btnBlock">
                    Send Link
                  </button>
                </div>
              </div>
              <div className="actnSec centerMob">
                <button type="button" className="appBtn">
                  <img src={IOS} />
                </button>
              </div>
              <div className="comingSoonTxt centerMob">
                <p>Coming soon to Android.</p>
              </div>
            </div>
            <div className="actntCntRgtCol">
              <div className="rftActImg">
                <img src={IMG} />
              </div>
            </div>
          </div>
        </div> */}

        <div className="container">
          <div className="acntContntRow">
            <div className="actntCntLeftCol">
              {utmSource !== REMITTANCE_SIGNUP && (
                <div className="check-inbox">
                  <div className="check-inbox-text">
                    {" "}
                    Check Your Inbox to Get the iOS App{" "}
                    <img
                      className="smily"
                      src={smily}
                      alt="Check Your Inbox to Get the Abound App"
                    />
                  </div>
                </div>
              )}

              <div className="getAppHed">
                <div className="hedSec">
                  {utmSource === "toi_js_bridge" && (
                    <>
                      {bankStatus === "confirmed_bank_link" && (
                        <>
                          <h2>
                            Welcome to the Club!
                            <br />
                            <span>Congrats your TOI+ is activated</span>
                          </h2>
                          <h3>
                            Download the app and sign in to see your reward.
                            Start earning cash back on exclusive offers today!
                          </h3>{" "}
                        </>
                      )}
                      {bankStatus !== "confirmed_bank_link" && (
                        <>
                          <h2>
                            We are linking your bank. It may take upto 5 mins
                            <br />
                          </h2>
                          <h3>
                            Your bank account is being submitted. Please do not
                            close the app or change the screen otherwise bank
                            link may fail.
                          </h3>{" "}
                        </>
                      )}
                    </>
                  )}
                  {utmSource !== "toi_js_bridge" && (
                    <>
                      <h2>
                        Welcome to the Club!
                        <br />
                        <span>We have $5 Waiting for You.</span>
                      </h2>
                      <h3>
                        Download the app and sign in to see your reward. Start
                        earning cash back on exclusive offers today!
                      </h3>{" "}
                    </>
                  )}
                </div>
              </div>
              {utmSource === REMITTANCE_SIGNUP && (
                <div className="qr1">
                  <img src={qr} />
                </div>
              )}

              <div className="actnSec">
                <button
                  onClick={() => downloadApp("iOS")}
                  className="appBtn"
                  type="button"
                >
                  <img src={applestore} alt="Click Here to Get iOS App" />
                </button>
                <button
                  onClick={() => downloadApp("Android")}
                  className="appBtn"
                  type="button"
                >
                  <img
                    style={{
                      width: "192px",
                      marginLeft: "8px",
                    }}
                    src={googleplay}
                    alt="Click here to get Android App"
                  />
                </button>
              </div>
              {userRewards.data.map((data) => {
                return (
                  <div className="subscribe-card active-state" key={data.id}>
                    <div>
                      <div className="subscrib-inner">
                        <div className="subscrib-img">
                          {" "}
                          <img
                            className="border-round"
                            src={
                              data.subscription_plan_trial.subscription_plan
                                .image_url
                            }
                            alt="subscription image"
                          />
                          {data.active === true && (
                            <div className="active-state-info">Active</div>
                          )}
                          {data.active === false && (
                            <div
                              style={{ background: "#e60000" }}
                              className="active-state-info"
                            >
                              Expired
                            </div>
                          )}
                        </div>
                        <div className="subscrib-info">
                          <h3 className="title-txt">
                            {
                              data.subscription_plan_trial.subscription_plan
                                .front_title
                            }
                          </h3>
                          <p className="discript-txt">
                            {
                              data.subscription_plan_trial.subscription_plan
                                .front_sub_title
                            }
                          </p>
                          <p className="billing-date">
                            {
                              data.subscription_plan_trial.subscription_plan
                                .site_url
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="actntCntRgtCol">
              <div className="rftActImg">
                {utmSource === REMITTANCE_SIGNUP ? (
                  <img
                    alt="app screen"
                    src="https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/File+(21).jpg"
                  />
                ) : (
                  <img
                    alt="app screen"
                    src="https://staticimages.timesclub.co/Website+images/New+Home+Page/homescreen.jpg"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AccountFooter />
    </div>
  );
}
export default GetApp;
